<div class="progress spinner">
    <div class="indeterminate"></div>
</div>
